import React from "react";
import PropTypes from "prop-types";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import { styled } from "@mui/material/styles";

import { useTranslation } from "../../context/Internationalization";
import { colors } from "../../theme/colors";
import TranslationToggle from "../TranslationToggle";

const { Base, Error, Grey } = colors;

const StyledMenu = styled(Menu)(() => ({
  "& .MuiPaper-root": {
    minWidth: 260,
    maxWidth: "calc(100vw - 32px)",
    borderRadius: 8,
    color: Grey[300],
    backgroundColor: Base.Black,
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 10px 20px, rgba(0, 0, 0, 0.12) 0px 6px 6px",
  },
  "& .MuiMenu-list": {
    padding: "6px 0",
  },
  "& .MuiMenuItem-root": {
    minHeight: 44,
    "&:hover": {
      backgroundColor: Grey[800],
    },
  },
}));

const AccountMenu = ({
  anchorEl,
  open,
  onClose,
  onOpenSettings,
  onLogout,
  opensUpward = false,
  showSettings = true,
}) => {
  const { t } = useTranslation();

  const handleSettings = () => {
    onClose();
    onOpenSettings();
  };

  const handleLogout = () => {
    onClose();
    onLogout();
  };

  return (
    <StyledMenu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: opensUpward ? "top" : "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: opensUpward ? "bottom" : "top",
        horizontal: "right",
      }}
      MenuListProps={{ "aria-label": t("account_menu") }}
    >
      {showSettings && (
        <MenuItem onClick={handleSettings}>
          <ListItemIcon sx={{ color: Grey[400] }}>
            <ManageAccountsOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="body2">{t("account_settings")}</Typography>
        </MenuItem>
      )}
      <TranslationToggle menuItem onChanged={onClose} />
      <Divider sx={{ borderColor: Grey[800], my: 0.5 }} />
      <MenuItem onClick={handleLogout} sx={{ color: Error[500] }}>
        <ListItemIcon sx={{ color: Error[500] }}>
          <LogoutOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <Typography variant="body2">{t("logout")}</Typography>
      </MenuItem>
    </StyledMenu>
  );
};

AccountMenu.propTypes = {
  anchorEl: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onOpenSettings: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  opensUpward: PropTypes.bool,
  showSettings: PropTypes.bool,
};

export default AccountMenu;
